module.exports = __webpack_public_path__ + "video/SERF25-0600-Sensitive_Information.bdfd8826.vtt";